import { slices } from "@/constants/sliceNames";
import axios from "axios";

import store from "../store/store";

import { API_ROOT } from "./apiConfig";

const axiosIns = axios.create({
  baseURL: API_ROOT,
  responseType: "blob",
});

export function downloadBlob(blob, name) {
  if (window.navigator && window.navigator.msSaveOrOpenBlob) return window.navigator.msSaveOrOpenBlob(blob);
  // For other browsers:
  // Create a link pointing to the ObjectURL containing the blob.
  const data = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = data;
  link.download = name;
  // this is necessary as link.click() does not work on the latest firefox
  link.dispatchEvent(
    new MouseEvent("click", {
      bubbles: true,
      cancelable: true,
      view: window,
    })
  );
  setTimeout(() => {
    // For Firefox it is necessary to delay revoking the ObjectURL
    window.URL.revokeObjectURL(data);
    link.remove();
  }, 100);
}

axiosIns.interceptors.request.use((config) => {
  config.headers["Authorization"] = `Bearer ${store.getState()[slices.auth].userToken}`;
  // config.headers["Access-Control-Allow-Origin"] = "*";
  return config;
});

export default axiosIns;
